import React, { useState, useEffect, useRef } from 'react';
import TR from './../../Trans';
import Button from '@mui/material/Button';
import BDialog from './BDialog';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import AlbumIcon from '@mui/icons-material/Album';
import { Capacitor } from '@capacitor/core';
import { Keyboard } from '@capacitor/keyboard';
import Tooltip from '@mui/material/Tooltip';
import AddPlayList from './AddPlayList';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import InfoIcon from '@mui/icons-material/Info';
import FormGroup from '@mui/material/FormGroup';
import DialogActions from '@mui/material/DialogActions';
import Stack from '@mui/material/Stack';
import DialogContent from '@mui/material/DialogContent';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import MenuItem from '@mui/material/MenuItem';
import AddSinger from './../dialogs/AddSinger';
import Select from '@mui/material/Select';
import TextField from '@mui/material/TextField';
import PitchButtons from '../items/PitchButtons';
import IconButton from '@mui/material/IconButton';
import PositionButtons from '../items/PositionButtons';
import SelectSongPosition from './SelectSongPosition';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import CreatorsDialog from './CreatorsDialog';
import MuvikaService from './../../services/muvika';
import sessionStore from './../../stores/session';
import messageStore from '../../stores/message';
import singersStore from './../../stores/singers';
import settingsStore from '../../stores/settings';
import accountStore from '../../stores/account';
import performanceStore from '../../stores/performance';
import bgSearchStore from '../../stores/bgSearch';
import navigationStore from '../../stores/navigation';
import Link from '@mui/material/Link';
import { Views } from './../../enums/enums';
import bgPerformanceStore from '../../stores/bgPerformance';

function BackgroundMusicEditPerformance(props) {

  const sessionToken = sessionStore((state) => state.sessionToken);
  const setError = messageStore((state) => state.setError);
  const settings = settingsStore((state) => state.settings);
  const account = accountStore((state) => state.account);
  const playQueue = bgPerformanceStore((state) => state.playQueue);
  const playLists = bgPerformanceStore((state) => state.playLists);

  const itemsOnPage = 25;
  const setSearchQuery = bgSearchStore((state) => state.setSearchQuery);
  const goToView = navigationStore((state) => state.goToView);
  const search = bgSearchStore((state) => state.search);
  const setOnlyArtist = bgSearchStore((state) => state.setOnlyArtist);

  const [currentPos, setCurrentPos] = useState(null);
  const [isSelectSongPositionOpen, setIsSelectSongPositionOpen] = useState(false);
  const [currentPlayList, setCurrentPlayList] = useState(null);
  const [isAddPlayListOpen, setIsAddPlayListOpen] = useState(false);

  const dialogRef = useRef(null);

  const handleOpenSelectSongPosition = () => {
    setIsSelectSongPositionOpen(true);
  };

  const handleCloseSelectSongPosition = () => {
    setIsSelectSongPositionOpen(false);
  };

  const handleOpenAddPlayList = () => {
    setIsAddPlayListOpen(true);
  };

  const handleCloseAddPlayList = () => {
    setIsAddPlayListOpen(false);
  };

  useEffect(() => {
    setCurrentPos(props.performance.position);
  }, [playQueue]);

  useEffect(() => {
    if (currentPlayList) {
      setCurrentPos(currentPlayList.items.length);
    } else if (playQueue) {
      setCurrentPos(props.performance.position);
    }
  }, [currentPlayList]);

  useEffect(() => {
    if (props.performance) {
      console.log(props.performance.position);
      setCurrentPos(props.performance.position);
    }
  }, [props.performance]);

  const handlePlayListChange = (event) => {
    let playListId = event.target.value;
    if (playListId != -1) {
      let playList = playLists.find(x => x.id == playListId);
      if (playList) {
        if(!playList.items){
          playList.items=[];
        }
        setCurrentPlayList(playList);
      }
    } else {
      setCurrentPlayList(null);
    }
  };

  const scrollToDown = () => {
    let dialogContainers = document.getElementsByClassName("MuiDialog-container");
    if (dialogContainers.length > 0) {
      for (var i = 0; i < dialogContainers.length; i++) {
        dialogContainers[i].scrollTop = dialogContainers[i].scrollHeight;
      }
    }
  };

  useEffect(() => {
    if (props.open) {
      if (Capacitor.isNativePlatform()) {
        Keyboard.addListener('keyboardDidShow', info => {
          setTimeout(() => scrollToDown(), 100);
          Keyboard.removeAllListeners();
        });
      } else {
        setTimeout(() => scrollToDown(), 100);
      }
      setCurrentPlayList(null);
      if (currentPlayList) {
        setCurrentPos(currentPlayList.items.length - 1);
      } else if (playQueue) {
        setCurrentPos(props.performance.position);
      }
    }
  }, [props.open]);

  const handlePosChange = (event) => {
    let pos = event.target.value;
    console.log(pos);
    if (pos || pos == 0) {
      pos = parseInt(pos);
      if (pos != -1) {
        setCurrentPos(pos);
      }
    } else {
      pos = -1;
    }
    if (pos === -1) {
      handleOpenSelectSongPosition();
    }
  };

  const playNextButton = () => {
    console.log(currentPos);
    if (accountStore.getState().account && settings) {
      if (accountStore.getState().account.subscription.valid != 0 && !settings.hide_play_now) {
        return <Button color="success" onClick={() => {
          editPerformance(true);
        }}><span className="muvika-playnow-icon"><PlayArrowIcon /></span> {TR.cm_play_now}</Button>;
      }
    }
  };

  const handleChoosePosition = (pos) => {
    if (pos || pos == 0) {
      if (currentPlayList) {
        if (pos >= currentPlayList.items.length) {
          setCurrentPos(currentPlayList.items.length);
        } else {
          setCurrentPos(pos);
        }
      } else {
        if (playQueue) {
          if (pos >= playQueue.items.length) {
            setCurrentPos(playQueue.items.length - 1);
          } else {
            setCurrentPos(pos);
          }
        }
      }
    }
    handleCloseSelectSongPosition();
  };

  const [creators, setCreators] = useState(null);

  const getCreators = () => {
    if (props.performance) {
      if (props.performance.track.track_id) {
        MuvikaService.getTrackCreators(sessionToken, props.performance.track.track_id)
          .then(function (res) {
            //console.log(res);
            if (res.data.data) {
              if (res.data.error) {
                setError(sessionToken, res.data.error.code, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
              } else {
                setCreators(res.data.data.items);
              }
            }
          })
          .catch(function () { });
      }
    }
  };

  const [isCreatorsDialogOpen, setIsCreatorsDialogOpen] = useState(false);

  const handleOpenCreatorsDialog = () => {
    getCreators();
    setIsCreatorsDialogOpen(true);
  };

  const handleCloseCreatorsDialog = () => {
    setIsCreatorsDialogOpen(false);
  };

  const playListList = () => {
    if (settings) {
      if (!settings.usage_mode || settings.usage_mode === "restaurant") {
        if (playLists) {
          return playLists.map((playList) =>
            <MenuItem key={playList.id} value={playList.id}>{playList.name}</MenuItem>
          );
        }
      }
    }
  };

  const playListContainer = () => {
    if (playLists) {
        return <FormGroup>
          <InputLabel id="new-playlist-label">{TR.cm_playlist}</InputLabel>
          <Grid container spacing={0}>
            <Grid item xs={10.5}>
              <Select
                className="muvika-dialog-select"
                labelId="new-playlist-label"
                label="Playlist"
                value={currentPlayList ? currentPlayList.id : -1}
                onChange={handlePlayListChange}
              >
                <MenuItem value={-1}>{TR.cm_current_music_playqueue}</MenuItem>
                {playListList()}
              </Select>
            </Grid>
            <Grid item xs={1.5}>
              {renderAddPlayListButton()}
            </Grid>
          </Grid>
        </FormGroup>;
    }
  };

  const renderChangeTrackButton = () => {
    if (props.onPerformanceToBeChanged) {
      return <Button variant="text" className="muvika-change-song-button" onClick={() => {
        props.onPerformanceToBeChanged();
        props.onClose();
      }}>{TR.cm_change_song}</Button>;
    }
  };

  const handlePlayListCreation = (playListName) => {
    if (playListName.length > 0) {
      console.log("handlePlayListCreation")
      MuvikaService.createMusicPlayList(sessionToken, playListName)
        .then(function (res) {
          if (res.data.error) {
            messageStore.getState().setError(sessionToken, res.data.error.code, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
          } else {
            bgPerformanceStore.getState().getPlayLists(sessionToken);
            let newPlayList = res.data.data;
            if(!newPlayList.items){
              newPlayList.items = [];
            }
            setCurrentPlayList(newPlayList);
            setIsAddPlayListOpen(false);
          }
        });
    }else{
      setError(sessionToken, 0, TR.cm_name_cannot_be_empty);
    }
  };

  const renderAddPlayListButton = () => {
    if (settings) {
      if (!settings.usage_mode || settings.usage_mode === "restaurant") {
        return <IconButton className="muvika-dialog-plus-button" color="white" component="label" onClick={handleOpenAddPlayList}>
          <AddCircleIcon />
        </IconButton>;
      }
    }
  };

  const editPerformance = (playNow = false) => {
    props.onEdit(playNow ? null : currentPlayList, playNow ? 0 : currentPos, playNow);
  };


  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      if (isCreatorsDialogOpen) {
        handleCloseCreatorsDialog();
      }else if (isAddPlayListOpen) {
        handlePlayListCreation();
      } else {
        editPerformance();
      }
    }
  };

  const renderPositionButtons = () => {
    if (settings) {
      let curPos = currentPos;
      if (currentPos || currentPos == 0) {
        if (curPos > 2) {
          curPos = -1;
        }
      }
      if (currentPlayList) {
        if (currentPos === currentPlayList.items.length) {
          curPos = currentPlayList.items.length;
        }
        return <Paper className="muvika-pos-buttons">
          <p className="muvika-pos-title">
            {TR.cm_performance_pos}
          </p>
          <PositionButtons
            value={curPos}
            performances={currentPlayList.items}
            onPosChange={handlePosChange}
            currentPosition={currentPos}
            isPlayQueue={false}
            isPlayList={true}
            isAdding={true}
          />
        </Paper>;
      } else if (playQueue) {
        if (currentPos === playQueue.items.length - 1) {
          curPos = playQueue.items.length - 1;
        }
        return <Paper className="muvika-pos-buttons">
          <p className="muvika-pos-title">
            {TR.cm_performance_pos}
          </p>
          <PositionButtons
            value={curPos}
            performances={playQueue.items}
            onPosChange={handlePosChange}
            currentPosition={currentPos}
            isPlayQueue={true}
            isAdding={false}
          />
        </Paper>;
      }
    }
  };

  const renderSelectSongPosition = () => {
    if (currentPlayList) {
      return <SelectSongPosition
        open={isSelectSongPositionOpen}
        onClose={handleCloseSelectSongPosition}
        track={props.performance.track}
        performances={currentPlayList.items}
        onChoosePosition={(pos) => {
          handleChoosePosition(pos);
        }}
      />;
    } else if (playQueue) {
      return <SelectSongPosition
        open={isSelectSongPositionOpen}
        track={props.track}
        onClose={handleCloseSelectSongPosition}
        performances={playQueue.items}
        performance={props.performance}
        onChoosePosition={(pos) => {
          handleChoosePosition(pos);
        }}
      />;
    }
  };

  const handleSearchArtist = () => {
    props.onClose();
    setOnlyArtist();
    setSearchQuery(props.performance.track.artist);
    search(sessionToken, itemsOnPage);
    goToView(Views.BackgroundMusicSearch);
  };

  return (
    <BDialog openToLeft={true} disableRestoreFocus ref={dialogRef} open={props.open} onKeyDown={handleKeyDown} onClose={props.onClose}>
      {renderSelectSongPosition()}
      <CreatorsDialog open={isCreatorsDialogOpen} onClose={handleCloseCreatorsDialog} creators={creators} track={props.performance.track} />
      <AddPlayList
        open={isAddPlayListOpen}
        onClose={handleCloseAddPlayList}
        onPlayListCreation={handlePlayListCreation}
      />
      <DialogContent>
        <div className="muvika-cover-music-image">
          <AlbumIcon />
        </div>
        <h4 className="muvika-track-title">
          <Link className="muvika-link-nodec" onClick={handleSearchArtist}>
            {props.performance.track.artist}
          </Link> - {props.performance.track.title} ({props.performance.track.kcode})
          <IconButton color="white" component="label" onClick={handleOpenCreatorsDialog}>
            <InfoIcon />
          </IconButton>
        </h4>
        <Stack spacing={0}>
          {playListContainer()}
          {renderPositionButtons()}
        </Stack>
      </DialogContent>
      <DialogActions>
        <Stack direction="row" spacing={4} justifyContent="center">
          <Button color="secondary" onClick={props.onClose}>{TR.cm_cancel}</Button>
          <Button
            color="success"
            className="muvika-dialog-action-right"
            onClick={() => editPerformance()}>{TR.cm_save}</Button>
             {playNextButton()}
        </Stack>
      </DialogActions>
    </BDialog>
  );
}

export default BackgroundMusicEditPerformance;